import React, { lazy, useCallback } from 'react';
import { Redirect, Switch, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { StatusCodes } from 'http-status-codes';

import DefaultLayout from 'app/layouts/DefaultLayout';
import HeadlessLayout from 'app/layouts/HeadlessLayout';
import routeDefinitions from 'enum/routeDefinitions';
import Loading from 'components/Loading/Loading';

import { fetchProfileInfo } from './dataFetchers';


const ProfileCluster = lazy(() => import('pages/ProfileV2/ProfileV2'));
const FanClub = lazy(() => import('./FanClub'));

const UserProfile = (props) => {
  const { user } = useParams();
  const { data, error } = useSWR([user], fetchProfileInfo, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const renderFanClubRoute = useCallback((isActive) => {
    if (!isActive) {
      return null;
    }

    return (
      <DefaultLayout
        Page={FanClub}
        exact={true}
        path={routeDefinitions.profileV2.fanclub}
        {...props}
      />
    );
  }, [props]);

  if (!data && !error) {
    return <Loading />;
  }

  if (error?.status === StatusCodes.NOT_FOUND) {
    return <Redirect to={routeDefinitions.pageNotFound} />;
  }

  if (error?.status === StatusCodes.UNAUTHORIZED) {
    return <Redirect to={routeDefinitions.root} />;
  }

  if (error?.status === StatusCodes.FORBIDDEN) {
    return <Redirect to={routeDefinitions.noProfile} />;
  }

  return (
    <Switch>
      {renderFanClubRoute(data?.hasNewFanClub)}

      <HeadlessLayout
        Page={ProfileCluster}
        embedProfileV2={true}
        exact={true}
        path={routeDefinitions.embedProfileV2}
        {...props}
      />

      <DefaultLayout
        Page={ProfileCluster}
        exact={true}
        path={routeDefinitions.profileV2.root}
        profilePage={true}
        showUnDockedVideo={true}
        {...props}
      />

      <DefaultLayout
        Page={ProfileCluster}
        path={routeDefinitions.profileV2.root}
        {...props}
      />
    </Switch>
  );
};

export default UserProfile;
